import { createColumnHelper } from "@tanstack/react-table";
import { XCircleIcon, CheckCircleIcon, ClockIcon } from "@heroicons/react/24/solid";

const columnHelper = createColumnHelper();

export const inventorySparesLotListTableColumnsConfig = (
  handleNavigateToLotDetail
) => [
  columnHelper.accessor("part_name", {
    header: "Part Name",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("color", {
    header: "Color",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("original_price", {
    header: "Original Price",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),
  columnHelper.accessor("discounted_price", {
    header: "Discounted Price",
    cell: (info) => info.getValue(),
    footer: (props) => props.column.id,
  }),

  // ===== Image Exist Column (Styled Like a Badge) =====
  columnHelper.accessor("image_exist", {
    header: "Image Status",
    cell: ({ getValue }) => {
      const status = getValue();

      const statusConfig = {
        0: { label: "No Image", bg: "#FDECEC", color: "#E53935", Icon: XCircleIcon },
        1: { label: "Image Exists", bg: "#E6F7EF", color: "#00A167", Icon: CheckCircleIcon },
        2: { label: "Scanning", bg: "#FFF4E5", color: "#FAAD14", Icon: ClockIcon },
      };

      const config = statusConfig[status] || statusConfig[0];
      const { label, bg, color, Icon } = config;

      return (
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "6px",
            padding: "4px 10px",
            borderRadius: "999px",
            fontSize: "12px",
            fontWeight: 500,
            backgroundColor: bg,
            color,
            whiteSpace: "nowrap",
            justifyContent: "center",
          }}
        >
          <Icon style={{ width: 14, height: 14 }} />
          {label}
        </div>
      );
    },
    footer: (props) => props.column.id,
  }),

  // ===== Actions Column =====
  columnHelper.display({
    id: "actions",
    header: <div style={{ textAlign: "center" }}>Actions</div>,
    cell: (props) => (
      <div
        style={{ display: "flex", justifyContent: "center", columnGap: "10px" }}
      >
        <button
          style={{
            padding: "6px 12px",
            background: "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)",
            color: "#FFFFFF",
            fontWeight: 500,
            fontSize: "13px",
            border: "none",
            borderRadius: "6px",
            cursor: "pointer",
            transition: "all 0.3s ease",
            boxShadow: "0 2px 6px rgba(47,53,103,0.3)",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #5561A0 0%, #7B82C0 100%)";
            e.currentTarget.style.boxShadow =
              "0 4px 12px rgba(47,53,103,0.35)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.background =
              "linear-gradient(135deg, #2F3567 0%, #5561A0 100%)";
            e.currentTarget.style.boxShadow =
              "0 2px 6px rgba(47,53,103,0.3)";
          }}
          onClick={() => handleNavigateToLotDetail(props.row.original.id)}
        >
          View Product Detail
        </button>
      </div>
    ),
  }),
];
